"use client";

import { useEnrollmentRounds } from "@/themes/default/templates/section/enrollment/useEnrollmentRounds";

/**
 * ci926 enrollment banner — indigo gradient card, gold-bar eyebrow, Poppins
 * heading, gold pill CTA + white outline pill (HeroEditorial idiom).
 */
export function EnrollmentBanner({
  section,
  currentLanguage = "mm",
}: {
  section: any;
  currentLanguage?: "en" | "mm";
}) {
  const d = useEnrollmentRounds(section, currentLanguage);
  if (!d) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8" lang={d.lang === "mm" ? "my" : "en"}>
      <div className="bg-ci926-gradient ci926-shadow overflow-hidden rounded-xl text-white">
        {d.rounds.map((r, i) => (
          <div
            key={r.id}
            className={`flex flex-col gap-5 px-6 py-6 md:flex-row md:items-center md:px-10 md:py-7 ${
              i > 0 ? "border-t border-white/15" : ""
            }`}
          >
            <div className="min-w-0 flex-1">
              <p
                className="flex items-center gap-2 text-[0.72rem] font-bold uppercase tracking-[0.12em]"
                style={{ color: "var(--ci926-gold)" }}
              >
                <span className="h-[3px] w-6 rounded-full" style={{ backgroundColor: "var(--ci926-gold)" }} aria-hidden="true" />
                {d.title}
              </p>
              <h2 className="ci926-heading mt-2 text-xl md:text-2xl" style={{ lineHeight: d.lang === "mm" ? 1.6 : 1.3 }}>
                {r.label}
              </h2>
              {r.window && (
                <p className="mt-1 text-sm text-white/80">
                  {d.t.windowPrefix} {r.window}
                </p>
              )}
            </div>
            <div className="flex shrink-0 flex-wrap gap-3">
              {r.listHref && (
                <a
                  href={r.listHref}
                  className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-transform hover:-translate-y-0.5"
                  style={{ color: "#fff", border: "1px solid rgba(255,255,255,0.55)" }}
                >
                  {d.t.list}
                </a>
              )}
              <a
                href={r.enrollHref}
                className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-transform hover:-translate-y-0.5"
                style={{
                  backgroundColor: "var(--ci926-gold)",
                  color: "var(--ci926-ink)",
                  boxShadow: "0 12px 28px -12px color-mix(in srgb, var(--ci926-gold) 70%, transparent)",
                }}
              >
                {d.t.enroll} <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
